import axios from 'axios';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

import React, { useState } from 'react';

import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}`;

export default function AddSkillItemNurse({
  openModal,
  setOpenModal,
  fetchData,
}) {
  const { auth } = useAuth();
  const [data, setData] = useState({
    item: '',
    roles: ['nurse'],
  });

  const handlePost = async () => {
    const skillPayload = {
      item: data?.item,
      roles: data?.roles || data?.role || ['nurse'],
    };

    const preferencePayload = {
      item: data?.item,
      role: data?.role || data?.roles || ['nurse'],
    };

    try {
      await Promise.all([
        axios.post(`${url}/admin/skill-items`, skillPayload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        }),
        axios.post(`${url}/preferences`, preferencePayload, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        }),
      ]);

      setData({ ...data });
      fetchData();

      toast.success('Item added successfully', {
        position: 'top-center',
        autoClose: 2000,
      });
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || 'Failed to add item', {
        position: 'top-center',
        autoClose: 2000,
      });
    }
  };

  return (
    <Dialog
      maxWidth='lg'
      fullwidth
      open={openModal}
      onClose={() => setOpenModal(false)}
    >
      <DialogTitle>Add new item</DialogTitle>
      <br />

      <DialogContent>
        <div className='flex justify-between'>
          <Box flex={1} mr={1}>
            <Typography fontFamily='Poppins'>Name*</Typography>
            <TextField
              fullWidth
              size='medium'
              variant='outlined'
              placeholder='Enter name'
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '6px',
                },
                mt: '5px',
                width: '300px',
              }}
              onChange={(e) =>
                setData({
                  ...data,
                  item: e.target.value,
                })
              }
            />
            <br />
            <br />
          </Box>
          <br />
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => setOpenModal(false)}
          color='secondary'
        >
          Done
        </Button>
        <Button
          sx={{ textTransform: 'none' }}
          color='primary'
          onClick={() => {
            handlePost();
            setOpenModal(false);
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
